module.exports = __webpack_public_path__ + "static/media/recycle_empty.a87239ea.ico";